import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { InjuryGroupsInterface } from '@interfaces/injuries.interface';
import { InjuryService } from '@/services/injury.service';
import { BaseComponent } from '../base.component';


@Component({
    selector: 'app-grouped-player-injuries',
    templateUrl: './grouped-player-injuries.component.html',
})
export class GroupedPlayerInjuriesComponent extends BaseComponent implements OnDestroy, OnInit {
    @Input()
    public sportId: number;

    @Input()
    public sportName: string;

    @Input() playerId!: number;

    @Input()
    public seasonId: number | null = null;

    @Input()
    public splitByGroup: boolean = true;

    public subscriber: Subscription;
    public injuryGroups: InjuryGroupsInterface | null = null;

    public constructor(
        private injuryService: InjuryService,
    ) {
        super();
    }

    ngOnInit(): void {
        this.load();
    }

    public ngOnDestroy(): void {
        this.subscriber.unsubscribe();
    }

    private async load(): Promise<any> {
        try {
            const data = await this.injuryService.getInjuryGroups(
                this.seasonId,
                null,
                [],
                false,
                null,
                this.playerId
            );

            this.subscriber = data.subscribe((data: InjuryGroupsInterface) => {
                this.injuryGroups = data;
            });
        } catch (e) {
            console.log(e);
        }
    }
}
